<template>
    <div class="mate-stic">
        <div class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>施工管理</el-breadcrumb-item>
                <el-breadcrumb-item>材料采购申请表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="mate-head">
            <div class="mate-head" style="">
                <div class="mate-head-left">材料类：</div>
                <div class="mate-head-r" :class="(allShow?'showAll':'')">
                    <p v-for="(item,index) in metaType" :key="index" @click="selctType(item)" class="mate-head-r-item" style="margin-bottom:5px;" :class="item.value==metaId?'cur':''">{{item.label}}</p>
                </div>
                <div class="mate-head-bottom" @click="showAllType">
                    <p v-if="!allShow"><i class="el-icon-arrow-down"></i>展开</p>
                    <p v-else><i class="el-icon-arrow-up"></i>隐藏</p>
                </div>
            </div>
            <div class="mate-head">
                <div class="mate-head-left">供应商：</div>
                <div class="mate-head-r">
                    <p v-for="(item,index) in supplierList" :key="index" @click="selctSupType(item)" class="mate-head-r-item" :class="item.id==supId?'cur':''">{{item.name}}</p>
                </div>
            </div>
            <div class="mate-head">
                <div class="mate-head-left">生产厂家：</div>
                <div class="mate-head-r">
                    <p v-for="(item,index) in oemList" :key="index" @click="selctOemType(item)" class="mate-head-r-item" :class="item.id==oemId?'cur':''">{{item.name}}</p>
                </div>
            </div>
            <div class="mate-head">
                <div class="mate-head-left">材料名称：</div>
                <div class="mate-head-r" style="padding-top: 5px;">
                    <el-input v-model="name" placeholder="请输入内容"></el-input>
                    <el-button type="primary" plain style="margin-left:1vw;">查询</el-button>
                </div>
            </div>
        </div>
        <div class="mate-head2">
            <div></div>
            <div>
                <el-button type="text" icon="el-icon-download">导入</el-button>
                <el-button type="text" icon="el-icon-upload2">导出</el-button>
                <el-button type="primary" size="small" @click="addFun">添加</el-button>
            </div>
        </div>
        <div class="mate-main">
            <el-table
              stripe
              :data="listData"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="100" center>
                    <template slot-scope="scope">
                        <a style="padding-left:1vw;">{{ scope.row.index}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="现场材料类" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.label}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="计划编号" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.materialCoding}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="材料名称" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.matrialName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="计量单位" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.matrialUnit}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="单价" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.matrialPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="数量" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.matrialNumber}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="金额" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.matrialTotalPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="供应商" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.matrialSupplier}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="生产厂家" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.matrialManufacturer}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="采购人" center>
                    <template slot-scope="scope">
                        <span>{{ scope.row.personName}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
            ></el-pagination>
        </div>
        <!-- 新增材料 -->
        <el-dialog width="580px" title="添加材料" :visible.sync="addVis" append-to-body>
            <el-form
            :model="addFrom"
            ref="addFrom"
            label-width="160px"
            label-position="right"
            :rules="rules"
            >   
                <el-form-item label="所属计划编号：" prop="fatherCoding">
                    <el-input v-model="addFrom.fatherCoding" autocomplete="off" style="width:300px;" @change="getInfo"></el-input>
                </el-form-item>
                <el-form-item label="采购编号："  prop="materialCoding">
                    <el-input v-model="addFrom.materialCoding" autocomplete="off" style="width:300px;">
                        <el-button slot="append" @click="createCode">生成编号</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="现场材料类：" prop="materialType">
                    <el-select v-model="addFrom.materialType" placeholder="请选择">
                        <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="材料名称："  prop="matrialName">
                    <el-input v-model="addFrom.matrialName" autocomplete="off" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="材料规格：" prop="matrialSpecification">
                    <el-input v-model="addFrom.matrialSpecification" autocomplete="off" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="计量单位：" prop="matrialUnit">
                    <el-input v-model="addFrom.matrialUnit" autocomplete="off" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="单价：" prop="matrialPrice">
                    <el-input type="number" v-model="addFrom.matrialPrice" @change="countFun" autocomplete="off" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="数量：" prop="matrialNumber">
                    <el-input type="number" v-model="addFrom.matrialNumber" @change="countFun" autocomplete="off" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="金额：">
                    <el-input v-model="addFrom.matrialTotalPrice" autocomplete="off" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="供应商：">
                  <el-select v-model="addFrom.supplierId" filterable placeholder="请选择">
                    <el-option
                      v-for="item in supplierList1"
                      :key="item.id"
                      :label="item.supplierName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="生产厂家：">
                  <el-select v-model="addFrom.manufacturerId" filterable placeholder="请选择">
                    <el-option
                      v-for="item in manufacturerList1"
                      :key="item.id"
                      :label="item.manufacturerName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitAdd('addFrom')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            allShow:false,
            name:'',
            metaType:[],//页头材料类型
            metaId:'',//当前页头材料id
            supplierList:[],//也有供应商列表
            supId:'',
            oemList:[],//生产厂家
            oemId:'',

            groupId:'',
            listData:[],
            dataText:'数据加载中...',

            //弹出框
            addVis:false,
            addFrom:{
                projectId:'',
                fatherCoding:'', //父级编码
                parentId:'',       //父级id
                materialType:'',   // 现场材料分类
                matrialState:'2',  //材料状态表，1申请计划，2采购申请，3入库统计，4消耗统计
                matrialName:'',    //材料名称
                matrialSpecification:'',//材料规格
                matrialUnit:'',      //计量单位
                matrialPrice:'',     //单价
                matrialNumber:'',    //数量
                matrialTotalPrice:'',// 总价格
                matrialSupplier:'',//供应商
                matrialManufacturer:'',//生产厂家
                materialCoding:'',//计划编号
                createBy:'',
                supplierId:'',//供应商id
                manufacturerId:'',//生产厂家id
            },
            supplierList1:[],     //供应商列表
            manufacturerList1:[], //生产厂家列表
            rules:{
                fatherCoding:[
                    { required: true, message: '请输入所属申请计划编号', trigger: 'blur' },
                ],
                materialCoding:[
                    { required: true, message: '请输入计划编号', trigger: 'blur' },
                ],
                materialType:[
                    { required: true, message: '请选择现场材料类型', trigger: 'change' },
                ],
                matrialName:[
                    { required: true, message: '请输入材料名称', trigger: 'blur' },
                ],
                matrialSpecification:[
                    { required: true, message: '请输入材料规格', trigger: 'blur' },
                ],
                matrialUnit:[
                    { required: true, message: '请输入计量单位', trigger: 'blur' },
                ],
                matrialPrice:[
                    { required: true, message: '请输入单价', trigger: 'blur' },
                ],
            },
            
            typeList:[],//弹出框材料类型
            currentPage:1,
            pageSize:10,
            totalItems:0,

            isSubmit:false,//是否正在提交
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getTypeList()
        this.getSupplierList()
        this.getOemList()
        this.getData()
    },
    methods:{
        //获取类型
        getTypeList(){
            var that = this
            myHttp.getDictByType({
                type:'material_type'
            }).then(function(resp){
                if (resp.data.code == '200') {
                    var list = resp.data.data.dictList||[]
                    that.typeList = JSON.parse(JSON.stringify(list))
                    var obj = {
                        id:'0',
                        label:'全部',
                        value:'',
                    }
                    list.unshift(obj)
                    that.metaType = list
                }
            })
        },
        //点击选择类型
        selctType(row){
            if(row.value!=this.metaId){
                this.currentPage = 1
                this.metaId = row.value
                this.getData()
            }
        },
        //获取供应商
        getSupplierList(){
            var that = this
            myHttp.selectMatProviderByType({
                groupId:this.groupId,
                userType:util.session.get('roleId'),
                type:'1'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    var obj = {
                        id:'',
                        name:'全部',
                    }
                    var result = []
                    result.push(obj)
                    for(var i=0;i<list.length;i++){
                        var str = {
                            id:list[i].id,
                            name:list[i].supplierName
                        }
                        result.push(str)
                    }
                    that.supplierList = result
                    that.supplierList1 = list
                }
            })
        },
        selctSupType(row){
            if(row.id!=this.supId){
                this.currentPage = 1
                this.supId = row.id
                this.getData()
            }
        },
        //获取生产厂家
        getOemList(){
            var that = this
            myHttp.selectMatProviderByType({
                groupId:this.groupId,
                userType:util.session.get('roleId'),
                type:'2'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    var obj = {
                        id:'',
                        name:'全部',
                    }
                    var result = []
                    result.push(obj)
                    for(var i=0;i<list.length;i++){
                        var str = {
                            id:list[i].id,
                            name:list[i].manufacturerName
                        }
                        result.push(str)
                    }
                    that.oemList = result
                    that.manufacturerList1 = list
                }
            })
        },
        selctOemType(row){
            if(row.id!=this.oemId){
                this.currentPage = 1
                this.oemId = row.id
                this.getData()
            }
        },
        //获取
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getData()
        },
        // 监控当前页码
        currentChangePage() {
            this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },
        getData(){
            var that = this
            myHttp.selectMatInfoPage({
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                projectId:this.groupId,
                matrialState:'2',
                materialType:this.metaId,
                matrialName:this.name,
                matrialSupplier:this.supId,
                matrialManufacturer:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
                    }
                    that.listData = list
                    that.totalItems = resp.data.data.pageInfo.total
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },

        //展开
        showAllType(){
            this.allShow = !!!this.allShow
        },

        //计算金额
        countFun(){
            if(this.addFrom.matrialPrice!=''&& this.addFrom.matrialNumber!=''){
                var val = parseFloat(this.addFrom.matrialPrice)
                var val1 = parseFloat(this.addFrom.matrialNumber)
                this.addFrom.matrialTotalPrice = val*val1
            }
        },
        //添加
        addFun(){
            this.addVis = true
            this.addFrom.materialType = ''
            this.addFrom.matrialName = ''
            this.addFrom.matrialSpecification = ''
            this.addFrom.matrialUnit = ''
            this.addFrom.matrialPrice = ''
            this.addFrom.matrialNumber = ''
            this.addFrom.matrialTotalPrice = ''
            this.addFrom.matrialSupplier = ''
            this.addFrom.matrialManufacturer = ''
            this.addFrom.materialCoding = ''
            this.addFrom.fatherCoding = ''
            this.addFrom.parentId = ''
        },
        //根据编号获取信息
        getInfo(){
            var that = this
            myHttp.selectOneByMaterialCoding({
                materialCoding:this.addFrom.fatherCoding,
                matrialState:'1',
                projectId:this.groupId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data.MatInformation
                    if(data){
                        that.addFrom.materialType = data.materialType
                        that.addFrom.matrialName = data.matrialName
                        that.addFrom.matrialSpecification = data.matrialSpecification
                        that.addFrom.matrialUnit = data.matrialUnit
                        that.addFrom.matrialPrice = data.matrialPrice
                        that.addFrom.matrialSupplier = data.matrialSupplier
                        that.addFrom.matrialManufacturer = data.matrialManufacturer
                        that.addFrom.parentId = data.id
                    }else{
                        that.$message.error('该计划不存在，请确定后输入')
                    }
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },
        //生成编号
        createCode(){
            var str = this.randomString(8)
            console.log(str)
            this.addFrom.materialCoding = 'MT' + str
        },
        randomString(len, charSet) {
            charSet = charSet || '0123456789'
            var randomString = ''
            for (var i = 0; i < len; i++) {
                var randomPoz = Math.floor(Math.random() * charSet.length)
                randomString += charSet.substring(randomPoz, randomPoz + 1)
            }
            return randomString
        },
        
        //提交
        submitAdd(formName){
            if(this.isSubmit){
                return;
            }
            this.isSubmit = true
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    that.addFrom.projectId = this.groupId
                    that.addFrom.createBy = util.session.get('user').id
                    if(that.addFrom.supplierId && that.addFrom.supplierId!=''){
                        that.addFrom.matrialSupplier = this.getNameById(1,that.addFrom.supplierId)
                    }
                    if(that.addFrom.manufacturerId && that.addFrom.manufacturerId!=''){
                        that.addFrom.matrialManufacturer = this.getNameById(2,that.addFrom.manufacturerId)
                    }
                    myHttp.addMatInformation(that.addFrom).then(function(resp){
                        if(resp.data.code=='200'){
                            that.$message.success('提交成功')
                            that.addVis = false
                            that.getData()
                        }else{
                            that.$message.error(resp.data.msg)
                        }
                        that.isSubmit = false
                    },function(){
                        that.isSubmit = false
                        that.$message.error(resp.data.msg)
                    })
                } else {
                    that.isSubmit = false
                    return false
                }
            })
        },

        //根据id获取名称
        getNameById(index,id){
            var name = ''
            var list = []
            if(index==1){
                list = this.supplierList1
            }else if(index==2){
                list = this.manufacturerList1
            }
            for(var i=0;i<list.length;i++){
                if(id==list[i].id){
                    name = index==1?list[i].supplierName:list[i].manufacturerName
                }
            }
            return name
        },
    }
}
</script>

<style scoped>
    .mate-stic{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .title-crumb{
        width: 100%;
        height: 4vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .mate-head{
        width: 100%;
        height: auto;
        position: relative;
        background: #fff;
        padding: 2vh 1vw 1vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        justify-items: flex-start;
        align-content: flex-start;
        align-items: flex-start;
        border-bottom: 5px solid #ecf0f5;
    }
    .mate-head .mate-head{
        border-bottom:0;
        padding: 0;
    }
    .mate-head-left{
        width: 7vw;
        position: relative;
        text-align: right;
        padding: 1vh 0;
    }
    .mate-head-r{
        width: calc( 100% - 10vw );
        position: relative;
        height: 5vh;
        overflow: hidden;
        text-align: left;
    }
    .mate-head-r.showAll{
        height: auto;
    }
    .mate-head-r-item{
        width: auto;
        position: relative;
        margin-right: 0.5vh;
        display: flex;
        align-items: center;
        float: left;
        /* margin-bottom: 1vh; */
        cursor: pointer;
        color: #3E50B4;
        padding: 1vh 1vw;
        border-radius: 5px;
    }
    .mate-head-r-item:hover,.mate-head-r-item.cur{
        background: #0490F9;
        color: #fff;
    }
    .mate-head-bottom{
        width: 3vw;
        display: flex;
        justify-items: flex-end;
        align-items: flex-end;
        min-height: 5vh;
        padding-bottom: 1vh;
        cursor: pointer;
    }
    .mate-head2{
        width: 100%;
        height: 6vh;
        position: relative;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        border-bottom: 5px solid #ecf0f5;
        padding: 0 1vw;
    }

    .mate-main{
        width: 100%;
        height: auto;
        position: relative;
    }
</style>

<style>

</style>